// This file is AUTOGENERATED, do not edit it manually!!!

export const resourcePlanning = {
    ability_to_fit_label: 'mogelijkheid om te passen',
    add_allocation_title: 'Toewijzing toevoegen',
    add_to_project: 'Toevoegen aan project',
    add_user_link: 'Gebruiker toevoegen',
    allocate_resources: 'Middelen toewijzen',
    allocated_label: 'Toegewezen',
    AllocatedHoursColumn: 'Toegewezen uren',
    allocation_approved_alert: 'Toewijzing is goedgekeurd door {0} op {1}',
    allocation_hard_label: 'Vast',
    allocation_has_been_created: 'Toewijzing is aangemaakt',
    allocation_has_been_updated: 'Toewijzing is bijgewerkt',
    allocation_percentage_label: 'Toewijzingspercentage',
    allocation_period_conflict: 'Deze periode omvat al een toewijzing',
    allocation_reject_alert: 'Toewijzing is afgewezen door {0} op {1}',
    allocation_request_approved_feedback: 'Middelenverzoek is goedgekeurd',
    allocation_request_rejected_feedback: 'Middelenverzoek is afgewezen',
    allocation_request_waiting_feedback: 'Middelenverzoek is aangemaakt',
    allocation_required: 'Toewijzing vereist',
    allocation_soft_label: 'Flexibel',
    allocation_type_change_with_approval_rquest_warning: 'Het wijzigen van het toewijzingstype naar vast resulteert in het verwijderen van het middelenverzoek',
    allocation_type_description: 'Vast - bevestigde toewijzing. Flexibel - voorlopige toewijzing.',
    allocation_type_label: 'Type toewijzing',
    allocation_waiting_alert: 'Toewijzing wacht op goedkeuring sinds {0}',
    approve_modal_header_text: 'Middelenverzoek goedkeuren voor {0}?',
    approve_request: 'Verzoek goedkeuren',
    Approve_Success_Message: '1#{0} toewijzing is goedgekeurd#{0} toewijzingen zijn goedgekeurd',
    approved_by: 'Goedgekeurd door',
    approver: 'Goedkeurder',
    AvailabilityTooltip: '% van de dagen voor de geplande toewijzingsduur, waarbij de persoon harde toewijzingen kan hebben op andere projecten, die niet alle capaciteit van de persoon zullen verbruiken op basis van het persoonlijke schema en vakanties en bedrijfsvakanties',
    available_label: 'Beschikbaar',
    available_projects: 'Beschikbare projecten',
    awaiting_approval_from: 'In afwachting van goedkeuring van',
    be_aware_all_will_be_transferred: 'Wees u ervan bewust dat alle toewijzingen, opdrachten en geplande uren worden overgezet naar de geselecteerde gebruiker.',
    calculate_based_message: 'Berekening van uren op basis van',
    capacity_label: 'Capaciteit',
    check_all: 'Alles selecteren',
    choice_description_generate_on_project_timeline: 'Toewijzingen (boekingen) worden gemaakt voor elk projectlid gedurende de hele duur van hun project',
    choice_description_generate_on_scheduled_hours: 'Toewijzingen (boekingen) worden alleen gemaakt voor taaktoewijzingen op basis van de geplande uren van hun toegewezen taken.',
    choice_title_generate_on_project_timeline: 'Toewijzingen genereren op basis van projecttijdlijnen',
    choice_title_generate_on_scheduled_hours: 'Toewijzingen genereren op basis van geplande uren',
    column_title_availability: 'Mogelijkheid om te passen, %',
    column_title_job_role: 'Match functierol',
    column_title_resource: 'Middel',
    column_title_skills: 'Match vaardigheden',
    column_title_user: 'Gebruiker',
    company_schedule_link: 'Bedrijfsschema',
    completed_projects_label: 'Voltooide projecten',
    demand_label: 'Vraag',
    Description_AllocatedMinutes: 'Hoeveelheid tijd die een middel reserveert om aan een project te wijden.',
    Description_HourlyRateInternal: 'Interne uurloon voor middelen.',
    Description_ScheduledMinutes: 'Aantal uren dat een middel is ingeroosterd om aan elke taak voor een project te besteden.',
    edit_allocation_title: 'Toewijzing bewerken',
    effortlessly_namage_resources_label: 'Middelen beheren zonder moeite met Resource Planning',
    find_candidates: 'Kandidaten zoeken',
    find_candidates_not_available_no_unnamed: 'Voeg anonieme middelen toe om de beste match te vinden om ze te vervangen',
    free: 'Vrij',
    generate_allocations_action: 'Toewijzingen genereren',
    generate_allocations_description: 'Toewijzingen worden gegenereerd op basis van de wekelijkse geplande uren voor dit middel.',
    generate_allocations_to_have_scheduled_hours: 'Om een planning te hebben - wijs het middel toe aan de taak met tijdlijnen en geschatte uren.',
    generate_button_warning_text: 'Het genereren van toewijzingen is veilig en zal geen invloed hebben op taakopdrachten of werklast op taakniveau wijzigen',
    group_by_job_role_label: 'Groeperen op functierol',
    group_by_project_label: 'Groeperen op project',
    group_by_resource_label: 'Groeperen op middel',
    HardAllocation: 'Vaste toewijzing',
    HardAllocationTooltip: 'Anonieme middelen kunnen alleen flexibel worden toegewezen',
    HourlyRateInternalColumn: 'Interne tarief',
    include_soft_allocations_to_workload: 'Flexibele toewijzingen opnemen in werklast',
    job_role_capacity: 'Functierol capaciteit',
    legend_title: 'Legenda',
    message: 'Bericht',
    message_tooltip: 'Voeg de afwijzings- of goedkeuringsreden toe, of een extra bericht. Het wordt toegevoegd als een apart bericht aan de projectdetails.',
    name_column_group_by_JobRole: 'Rollen, middelen en projecten',
    name_column_group_by_Project: 'Projecten en middelen',
    name_column_group_by_User: 'Middelen en projecten',
    no_jobrole: 'Er zijn geen functierollen zichtbaar voor u',
    no_jobrole_match_selected_filters: 'Sorry, geen functierol match geselecteerde filters',
    no_project: 'Er zijn geen projecten zichtbaar voor u',
    no_project_match_selected_filters: 'Sorry, geen projectmatch geselecteerde filters',
    no_scheduled_hours_description: 'Er zijn geen geplande uren voor de taaktoewijzingen voor dit middel.',
    no_user: 'Er zijn geen middelen zichtbaar voor u',
    no_user_match_selected_filters: 'Sorry, er zijn geen resources gevonden die voldoen aan de geselecteerde filters.',
    other_hard_allocations: 'Andere harde toewijzingen',
    other_projects_label: 'Andere projecten',
    other_projects_tooltip: 'Dit zijn projecten die niet onder de toegepaste filters vallen of waarvoor je niet de benodigde toestemming hebt om toegang te krijgen.',
    over: 'Over',
    overloaded_label: 'Overbelast',
    overscheduled_hours_label: 'Geplande uren overschreden',
    planning_onboarding_description: 'Een krachtige tool om resources op projectniveau te boeken, met een overzicht van het gebruik van resources over alle projecten om je te helpen weloverwogen strategische beslissingen te nemen.',
    planning_onboarding_title: 'Welkom bij de nieuwe Resource Planning functie!',
    project_timeline_label: 'Project tijdlijn',
    recommended_users_label: 'Aanbevolen gebruikers door AI',
    regular_workload_label: 'Reguliere workload',
    reject_modal_header_text: 'Afwijzen resource aanvraag voor {0}?',
    reject_request: 'Afwijzen aanvraag',
    Reject_Success_Message: '1#{0} toewijzing is afgewezen#{0} toewijzingen zijn afgewezen',
    rejected_by: 'Afgewezen door',
    remaining_total_capacity: 'Resterende totale capaciteit',
    remaining_user_capacity: 'Resterende gebruikerscapaciteit',
    replace_unnamed_with_real_to_approve_allocation: 'Vervang een naamloze resource door een echte gebruiker om de toewijzing goed te keuren.',
    replace_with_a_user: 'Vervangen door een gebruiker',
    request_for_approval_label: 'Aanvraag voor goedkeuring',
    request_from: 'Aanvraag vanaf',
    resource_allocated_plural: '1#{0} resource is toegewezen#{0} resources zijn toegewezen',
    resource_approval_selector_disabled_label: 'Resource goedkeuringen zijn alleen beschikbaar voor zachte toewijzingen',
    resource_types_disabled_user_label: 'Uitgeschakelde gebruikers',
    scheduled_hours_label: 'Geplande uren',
    see_detailed_allocations: 'Zie gedetailleerde toewijzingen',
    select_user: 'Gebruiker selecteren',
    SkillsColumn: 'Vaardigheden',
    SoftAllocation: 'Zachte toewijzing',
    streamline_your_project: 'Stroomlijn je projectmanagement door resources effectief toe te wijzen en te volgen.',
    total_allocated_hours_calculation_description: 'Aantal uren dat de resource gepland is om te werken aan het project, berekend op basis van de werkuren, weekenden, nationale feestdagen die in de bedrijfsinstellingen zijn gedefinieerd.',
    total_allocated_hours_calculation_formula: 'Totaal toegewezen uren = (toewijzingsduur - nationale feestdagen) * bedrijfs werkuren * toewijzingspercentage',
    total_allocated_hours_label: 'Totaal toegewezen uren',
    total_demand: 'Totale vraag',
    uncheck_all: 'Alles deselecteren',
    underloaded_label: 'Onderbelast',
    unnamed_resource_allocation: 'Naamloze resource toewijzing',
    unnamed_resource_demand: 'Naamloze resource vraag',
    unnamed_workload_label: 'Naamloze resource workload',
    user_demand: 'Gebruikersvraag',
    users_select_empty_text: 'Je hebt geen beschikbare gebruikers.',
    vacation_label: 'Vakantie',
    working_hours_message: 'Werkuren - {0} per dag.',
};
